export default {
  ACCEPT_VALUE: 'accept',
  DECLINE_VALUE: 'decline',
  NO_SELECTION: 'NONE',
};
